import CloseIcon from "@uui/XClose";

import { SxProps } from "@mui/material";

import IconButton from "@rui/IconButton";
import { ModalTitle } from "@rui/Modal/index";
import { Row } from "@rui/Stack";

interface ModalHeaderProps {
  title?: string;
  onClose?: (event: React.MouseEvent) => void;
  sx?: SxProps;
  renderIcon?: React.ReactNode;
}

const ModalHeader = ({ title, onClose, renderIcon, sx }: ModalHeaderProps) => {
  return (
    <Row
      variant="apart"
      sx={{ minHeight: "34px", width: "100%", ...sx }}
      spacing="12px"
    >
      {title && <ModalTitle>{title}</ModalTitle>}
      {onClose && (
        <IconButton onClick={onClose}>
          {renderIcon ? renderIcon : <CloseIcon />}
        </IconButton>
      )}
    </Row>
  );
};

export default ModalHeader;
